<template>
    <div id="appointment-calendar" class="hm-calendar-container">
        <div class="row">
            <div class="col-12">
                <div class="card border-0">
                    <div class="card-header d-flex justify-content-between align-items-center text-black p-2">
                        <div class="d-flex gap-2">
                            <div class="d-flex gap-1">
                                <PreviousDateIcon 
                                    v-model="currentDate" 
                                    decrement="month"
                                />
                                <NextDateIcon 
                                    v-model="currentDate" 
                                    increment="month"
                                />
                                <CalendarIcon 
                                    v-model="currentDate" 
                                    :auto-apply="true" 
                                    :month-picker="true"
                                />
                            </div>
                            <!-- Display Date -->
                            <div class="d-flex">
                                {{ momentObj(currentDate).format('MMM YYYY').toUpperCase() }}
                                <div class="ms-4">Appointments Management</div>
                            </div>
                        </div>
                        <a href="/admin/appointments/create" class="btn btn-sm btn-theme float-end">
                            <i class="bi bi-plus-circle pe-1"></i> Create Appointment
                        </a>
                        <!-- <span class="card-title p-0 m-0">
                            Appointments Management 
                            <a href="/admin/appointments/create" class="btn btn-sm btn-theme float-end">
                                <i class="bi bi-plus-circle pe-1"></i> Create Appointment
                            </a>
                        </span> -->
                    </div>
                    <!-- <div class="card-body p-0">
                        <div class="d-flex justify-content-between p-3">
                            <h3 class="p-0 m-0">
                                {{ displayDate.toUpperCase() }}
                            </h3>
                            <div class="d-flex gap-2">
                                <div class="row justify-content-end">
                                    <div class="col-auto pe-0">
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            @click="resetFilter"
                                        >Reset</button>
                                    </div>
                                    <div class="col-auto pe-0 hm-db--date-filter" style="width: 150px;">
                                        <Select2
                                            v-model="filters.searchType"
                                            :options="filterOptions"
                                            :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Filter Order', width: '100%' }"
                                            class=""
                                        />
                                    </div>
                                    <div class="col-auto pe-0">
                                        <button
                                            type="button"
                                            class="btn btn-sm"
                                            :class="[filters.searchType === 'today' ? 'btn-theme' : 'btn-outline-theme']"
                                            @click="filters.searchType='today'"
                                        >Today</button>
                                    </div>
                                    <div class="col-auto pe-0">
                                        <button
                                            type="button"
                                            class="btn btn-sm"
                                            :class="[filters.searchType === 'tomorrow' ? 'btn-theme' : 'btn-outline-theme']"
                                            @click="filters.searchType='tomorrow'"
                                        >Tomorrow</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="card-body p-0 border-0">
                        <div class="hm-due-date-table">
                            <!-- Display monthly data -->
                            <table class="table table-bordered mb-0 hm-table-fixed">
                                <thead class="due-date-table-head">
                                <tr>
                                    <td
                                        class="text-center"
                                        v-for="(day, index) in weekDays"
                                        :key="index"
                                    >{{ day }}</td>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(week, index) in monthDates" :key="index">
                                        <td
                                            v-for="(dateInfo, dateIndex) in week"
                                            :key="dateIndex"
                                            class=""
                                        >
                                            <div v-if="dateInfo" class="position-relative hm-calendar-box">
                                                <div class="hm-label-day">{{ dateInfo.date }}</div>
                                                <div class="mx-auto">
                                                    <template
                                                        v-for="appointment in appointments"
                                                        class="order-list-group"
                                                    >
                                                        <div v-if="appointment.day_of_month == dateInfo.date"
                                                             class="hm-service-card p-2 mb-1 rounded order-list-group-item cursor-pointer"
                                                             :class="getRandomClass()"
                                                             @click="viewAppointment(appointment)"
                                                        >
                                                            <div class="d-flex justify-content-between align-items-start pt-2">
                                                                <div class="d-flex flex-col gap-2">
                                                                    <label v-if="appointment.title">
                                                                        {{ $truncateString(appointment.title, 22) }}
                                                                    </label>
                                                                    <label v-if="appointment.name">{{ $truncateString(appointment.name,22) }}</label>
                                                                    <label v-if="appointment.appointment_start && appointment.appointment_end">
                                                                        {{ appointment.appointment_start }} - {{ appointment.appointment_end }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { appMixin } from '../mixin/appMixin';
import Select2 from "vue3-select2-component";
import CalendarIcon from "./partials/CalendarIcon.vue";
import PreviousDateIcon from "./partials/PreviousDateIcon.vue";
import NextDateIcon from "./partials/NextDateIcon.vue";

export default {
    components: {
        Select2,
        CalendarIcon,
        PreviousDateIcon,
        NextDateIcon
    },
    mixins: [appMixin],
    data() {
        return {
            weekDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            monthDates: [],
            screenHeight: "",
            currentPeriodStart: moment(),
            filters: {
                search: "",
                searchType: 'this_month',
            },
            filterOptions: [
                {id: 'this_week', text: 'This Week'},
                {id: 'next_week', text: 'Next Week'},
                {id: 'this_month', text: 'This Month'},
                {id: 'next_month', text: 'Next Month'},
            ],
            displayDate: moment().format('MMM YYYY'),
            appointments: [],
            currentDate: this.momentObj().startOf('month').toDate(),
        }
    },

    mounted() {
        this.screenHeight = window.innerHeight - 150;

        window.addEventListener("resize", () => {
            this.screenHeight = window.innerHeight - 150;
        });

        this.initializeCalendar();

        this.getAppointments();
    },
    methods: {
        initializeCalendar() {
            this.monthDates = this.prepareCalendarDate(this.currentDate);
            this.getAppointments();
            return;
        },
        getAppointments() {
            let self = this;
            axios.post('/admin/appointments/list', {
                start_date: this.momentObj(this.currentDate).startOf('month').format('YYYY-MM-DD'),
                end_date: this.momentObj(this.currentDate).endOf('month').format('YYYY-MM-DD'),
            })
                .then(response => {
                    self.appointments = response.data.appointments;
                });
        },
        getRandomClass() {
            let cardItemClasses = [
                "task-bg-green",
                "task-bg-light-green",
                "task-bg-purple",
                "task-bg-orange",
                "task-bg-warning",
                "task-bg-blue",
                "task-bg-default",
                "task-bg-pink",
            ];
            return cardItemClasses[Math.floor(Math.random() * cardItemClasses.length)];
        },
        viewAppointment(appointment) {
            window.location.href = "/admin/appointments/" + appointment.id + "/edit";
        }
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.getAppointments();
            }
        },
        currentDate: {
            handler(newVal, oldVal) {
                this.initializeCalendar();
            },
            immediate: true
        }
    }
}
</script>
<style scoped>
.calendar {
    display: flex;
    flex-direction: column;
}
.week-days, .week {
    display: flex;
}
.day-header, .date {
    flex: 1 0 14%; /* approximately 14% to fit 7 items in a row */
    text-align: center;
    border: 1px solid #ccc;
    padding: 8px;
}
.empty-date {
    background-color: #f0f0f0; /* Light gray background for empty dates */
}
</style>
